/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import EmbeddedPromoTemplatePageByPageData from 'bundles/promo-template/components/EmbeddedPromoTemplatePageByPageData';
import type { PageData } from 'bundles/promo-template/queries/hooks/useEmbeddedPageContentQuery';

type Props = {
  page: PageData;
};

const styles = {
  container: css`
    margin: var(--cds-spacing-400) auto;

    /* cancel the striped background to avoid duplicate background with promo-template */
    background-color: transparent !important;
  `,
};

const EmbeddedPromoTemplatePageModule = ({ page }: Props) => {
  return (
    <div css={styles.container}>
      <EmbeddedPromoTemplatePageByPageData page={page} />
    </div>
  );
};

export default EmbeddedPromoTemplatePageModule;
